import { Templates } from '../compile';

export const DefaultListPropertyEditTemplateMapping = {
	//[PropertyType.BOOLEAN]: Templates.list_cell_boolean,
	//[PropertyType.DATE]: Templates.list_cell_input,
	//[PropertyType.EMAIL]: Templates.list_cell_input,
	//[PropertyType.IMAGE]: Templates.list_cell_input,
	//[PropertyType.EMAIL]: Templates.list_cell_input,
	//[PropertyType.NUMBER]: Templates.list_cell_input,
	//[PropertyType.STRING]: Templates.list_cell_input
	// Fix for "A computed property name in a type literal must directly refer to a built-in symbol." in definition file --> ideas?
	0: Templates.list_cell_boolean,
	1: Templates.list_cell_input,
	2: Templates.list_cell_input,
	3: Templates.list_cell_input,
	4: Templates.list_cell_input,
	5: Templates.list_cell_input
};
